import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, carrierValidations } from "./carrier-schema";
import { createCarrier } from "services/data.internal.service";
import CarrierInfo from "./components/CarrierInfo";

function AddCarrier() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createCarrierMutation = useMutation(createCarrier, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({ defaultValues: initialValues, resolver: yupResolver(carrierValidations) });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = { control, errors, setValue, formRender };
  const onSubmit = (data) => {
    createCarrierMutation.mutate(data, {
      onSuccess: () => reset(),
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CarrierInfo {...infoProps} />
        <SubmitButton label="submit" disabled={isSubmitting} url="/setup/carrier" />
      </form>
    </Layout>
  );
}

export default AddCarrier;
